import { render, staticRenderFns } from "./OrganisationSidebar.vue?vue&type=template&id=1d7d0962&scoped=true"
import script from "./OrganisationSidebar.vue?vue&type=script&lang=js"
export * from "./OrganisationSidebar.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSidebar.vue?vue&type=style&index=0&id=1d7d0962&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7d0962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7d0962')) {
      api.createRecord('1d7d0962', component.options)
    } else {
      api.reload('1d7d0962', component.options)
    }
    module.hot.accept("./OrganisationSidebar.vue?vue&type=template&id=1d7d0962&scoped=true", function () {
      api.rerender('1d7d0962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationSidebar.vue"
export default component.exports